import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const HiddenField = styled.div`
  display: none;
  position: absolute;
  left: -9999px;
`;

interface BotPreventionProps {
  onValidationChange: (isValid: boolean) => void;
  formId: string;
}

/**
 * Invisible bot prevention that uses honeypot fields and timing
 * to detect and prevent bot submissions without user interaction
 */
const BotPrevention: React.FC<BotPreventionProps> = ({ onValidationChange, formId }) => {
  const [honeypot, setHoneypot] = useState('');
  const [startTime] = useState(Date.now());
  
  // Monitor time on page to verify it's not an instant bot submission
  useEffect(() => {
    const timer = setInterval(() => {
      const currentTime = Date.now() - startTime;
      
      // Consider human after 1.5 seconds if honeypot is empty
      if (currentTime > 1500 && honeypot === '') {
        onValidationChange(true);
      }
    }, 500);
    
    return () => clearInterval(timer);
  }, [startTime, honeypot, onValidationChange]);
  
  return (
    <HiddenField>
      {/* Honeypot field that should remain empty */}
      <input
        type="text"
        name={`website_${formId}`}
        id={`website_${formId}`}
        value={honeypot}
        onChange={(e) => {
          setHoneypot(e.target.value);
          // If field is filled, it's likely a bot
          if (e.target.value) {
            onValidationChange(false);
          }
        }}
        tabIndex={-1}
        autoComplete="off"
      />
      
      {/* Additional hidden field to catch smarter bots */}
      <input
        type="checkbox"
        name={`newsletter_${formId}`}
        id={`newsletter_${formId}`}
        tabIndex={-1}
        onChange={() => onValidationChange(false)}
      />
    </HiddenField>
  );
};

export default BotPrevention; 